import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  CardBody,
  InputGroup,
} from "reactstrap"
import InfoMeAction from "store/me-resource/actions"
import { Stage, Layer, Line, Text, Image, Transformer, Star } from "react-konva"
import * as Unicons from "@iconscout/react-unicons"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getSheets, addNewSheet } from "store/canvas/action"
import { v4 as uuidv4 } from "uuid"
import useImage from "use-image"
import Listen from "../../helpers/Listen"

const Canvas = () => {
  const dispatch = useDispatch()
  const state = useSelector(state => state)
  const history = useHistory()
  const params = new URLSearchParams(location.search)
  const id = params.get("id")
  const [activeCanvas, setActiveCanvas] = useState(0)
  const [jsonCanvas, setJsonCanvas] = useState([])
  // const [] = useState
  const [selectedImage, setSelectedImage] = useState("")
  const [imageAtCanvas, setImageAtCanvas] = useState([])
  const [refresh, setRefresh] = useState(true)
  const [imageList, setImageList] = useState(null)
  const dragUrl = React.useRef()
  const stageRef = React.useRef()
  const sideBarRef = React.useRef()
  const divRef = useRef(null)
  const fileRef = useRef()

  const INITIAL_CANVAS = {
    id: uuidv4(),
    images: [],
    lines: [],
  }

  React.useEffect(() => {
    dispatch(InfoMeAction.getInfoMe())
  }, [])

  React.useEffect(() => {
    getSheet()
  }, [])

  React.useEffect(() => {
    if (refresh === true) {
      if (
        state.orderSheetCanvas.sheets === null ||
        state.orderSheetCanvas.sheets?.jsonArray.length === 0 ||
        state.orderSheetCanvas.sheets?.jsonArray[0] === null
      ) {
        setJsonCanvas([...jsonCanvas, INITIAL_CANVAS])
      } else {
        setJsonCanvas(state.orderSheetCanvas.sheets.jsonArray)
      }
    }
    setImageList(state.orderSheetCanvas.sheets?.images)
  }, [state.orderSheetCanvas.sheets])

  React.useEffect(() => {
    setImageList(state.orderSheetCanvas.sheets?.images)
  }, [state.orderSheetCanvas])

  React.useEffect(() => {
    Listen.addListener("back", eventResponse)
    return () => Listen.removeListener("back", eventResponse)
  }, [])

  const eventResponse = payload => {
    history.goBack()
  }

  const getSheet = () => {
    dispatch(getSheets(id))
  }

  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    sideBar: 0,
  })

  const chooseFile = e => {
    fileRef.current.click()
  }

  useEffect(() => {
    if (divRef.current?.offsetHeight && divRef.current?.offsetWidth) {
      setDimensions({
        width: document.getElementById("canvas-container").clientWidth,
        height: divRef.current.offsetHeight,
        sideBar: sideBarRef.current?.offsetWidth,
      })
    }
  }, [dimensions.height])

  const handleDragStart = e => {
    const id = e.target.id()
  }
  const handleDragEnd = e => {
    const findIndexImage = jsonCanvas[activeCanvas].images.findIndex(
      image => image.id === e.imageProps.id
    )
    const cpArr = [...jsonCanvas]
    cpArr[activeCanvas].images[findIndexImage].x = e.e.target.x()
    cpArr[activeCanvas].images[findIndexImage].y = e.e.target.y()
    setJsonCanvas(cpArr)
  }

  const handleTransformEnd = e => {
    const findIndexImage = jsonCanvas[activeCanvas].images.findIndex(
      image => image.id === e.id
    )
    const cpArr = [...jsonCanvas]
    cpArr[activeCanvas].images[findIndexImage].height = e.height
    cpArr[activeCanvas].images[findIndexImage].width = e.width

    setJsonCanvas(cpArr)
  }

  const saveProductImages = e => {
    const files = e.target.files
    const body = {
      files,
      id,
    }
    setRefresh(false)
    dispatch(addNewSheet(body))
  }

  const saveCanvas = async e => {
    const body = {
      jsonCanvas,
      id,
      history: history.goBack(),
    }

    await dispatch(addNewSheet(body))
  }

  const addCanvas = () => {
    setJsonCanvas(jsonCanvas => [...jsonCanvas, INITIAL_CANVAS])
  }

  const removeCanvas = () => {
    const cpArr = [...jsonCanvas]
    cpArr.pop()
    setJsonCanvas(cpArr)
  }

  const nextPrev = par => {
    if (par === "next") {
      if (activeCanvas === jsonCanvas.length - 1) {
        return
      } else {
        setActiveCanvas(activeCanvas + 1)
      }
    } else {
      if (activeCanvas === 0) {
        return
      } else {
        setActiveCanvas(activeCanvas - 1)
      }
    }
  }

  const storeCanvasImage = (image, e) => {
    const cpArr = [...jsonCanvas]
    const initImage = {
      id: uuidv4(),
      img: image,
      x: e.x - 80 ?? 0,
      y: e.y - 80 ?? 0,
      transformX: 0,
      transformY: 0,
      height: image.height,
      width: image.width,
    }
    cpArr[activeCanvas].images.push(initImage)
    setJsonCanvas(cpArr)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"手書画像管理"}
            // breadcrumbItem={`${isActiveTab.item}`}
            breadcrumbList={[]}
          />
          <Card>
            <CardBody className="p-3">
              <Row>
                <Col className="col-xl-9 col-sm-8 d-flex flex-row justify-content-center align-items-center">
                  <div className="d-flex flex-row justify-center align-items-center">
                    <Unicons.UilArrowLeft
                      role="button"
                      size="30"
                      color="#000"
                      onClick={() => nextPrev("prev")}
                    />
                    <div style={{ marginRight: 10, marginLeft: 4 }}>ページ</div>
                    <div style={{ marginRight: 10, fontWeight: "bold" }}>
                      {activeCanvas + 1} / {jsonCanvas.length}
                    </div>
                    <Unicons.UilArrowRight
                      role="button"
                      size="30"
                      color="#000"
                      onClick={() => nextPrev("next")}
                    />
                  </div>
                </Col>
                <Col className="col-xl-3 col-sm-4 justify-end align-items-end">
                  <Button
                    className={["w-100 rounded border bg-primary"].join(" ")}
                    onClick={() => saveCanvas()}
                  >
                    保存
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Row>
            <Col className="col-9">
              <Card>
                <CardBody className="p-3">
                  <div
                    ref={divRef}
                    style={{
                      width: "100%",
                      height: "65vh",
                    }}
                    onDrop={e => {
                      e.preventDefault()
                      stageRef.current.setPointersPositions(e)
                      storeCanvasImage(
                        dragUrl.current,
                        stageRef.current.getPointerPosition()
                      )
                    }}
                    onDragOver={e => e.preventDefault()}
                    id="canvas-container"
                  >
                    <Stage
                      width={dimensions.width}
                      height={dimensions.height}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid grey",
                      }}
                      ref={stageRef}
                    >
                      <Layer
                        width={dimensions.width}
                        height={dimensions.height}
                      >
                        {jsonCanvas.length > 0 &&
                          jsonCanvas[activeCanvas]?.images.map((image, i) => {
                            return (
                              <Images
                                key={i}
                                imageProps={image}
                                isSelected={image.id === selectedImage}
                                onSelect={() => {
                                  setSelectedImage(image.id)
                                }}
                                onChange={newAttrs => {
                                  const image = imageAtCanvas.slice()
                                  //   rects[i] = newAttrs;
                                  //   setRectangles(rects);
                                  handleTransformEnd(newAttrs)
                                }}
                                handleDragEnd={v => handleDragEnd(v)}
                                handleTransformEnd={v => handleTransformEnd(v)}
                              />
                            )
                          })}
                      </Layer>
                    </Stage>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col className="col-3">
              <Card>
                <CardBody className="p-3 h-100">
                  <div ref={divRef} style={{ width: "100%", height: "65vh" }}>
                    <Row style={{ height: "25%" }}>
                      <Col className="col-4 d-flex align-items-center justify-center">
                        ページ数
                      </Col>
                      <Col className="col-8">
                        {/* <Input
                          name="sheet"
                          type="number"
                          placeholder="Enter Sheet"
                          onChange={addCanvas}
                          value={jsonCanvas.length}
                        /> */}
                        <InputGroup>
                          <div
                            className="input-group-append"
                            onClick={() => {
                              jsonCanvas.length === 1 ? null : removeCanvas()
                            }}
                          >
                            <Button type="button" color="primary">
                              <i className="mdi mdi-minus" />
                            </Button>
                          </div>
                          <input
                            type="number"
                            className="form-control"
                            value={jsonCanvas.length}
                            placeholder="number"
                            readOnly
                          />
                          <div
                            className="input-group-append"
                            onClick={() => {
                              addCanvas()
                            }}
                          >
                            <Button type="button" color="primary">
                              <i className="mdi mdi-plus" />
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col className="col-12">
                        <Button
                          className={[
                            "w-100 rounded border bg-primary mt-2 ",
                          ].join(" ")}
                          onClick={() => chooseFile()}
                        >
                          参照
                        </Button>
                      </Col>
                      <Col className="col-12">
                        <input
                          type="file"
                          ref={fileRef}
                          accept=".jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          multiple
                          onChange={saveProductImages}
                        />
                        <div className="mt-4 mb-2">ファイルリスト</div>
                      </Col>
                    </Row>

                    <Row style={{ height: "75%" }}>
                      <Col className="overflow-auto" style={{ height: "100%" }}>
                        <div className="mt-2 ">
                          {imageList &&
                            imageList.map((image, i) => (
                              <img
                                key={i}
                                src={image}
                                className="w-100 mb-4 rounded"
                                onClick={() => {
                                  storeCanvasImage(image)
                                }}
                                draggable="true"
                                onDragStart={e => {
                                  dragUrl.current = e.target.src
                                }}
                                onDragOver={e => e.preventDefault()}
                              />
                            ))}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const Images = ({
  imageProps,
  isSelected,
  onSelect,
  onChange,
  handleDragEnd,
  handleTransformEnd,
}) => {
  const shapeRef = React.useRef()
  const trRef = React.useRef()
  const [image] = useImage(imageProps.img)

  React.useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current])
      trRef.current.getLayer().batchDraw()
    }
  }, [isSelected])

  return (
    <React.Fragment>
      <Image
        onClick={onSelect}
        onTap={onSelect}
        image={image}
        x={imageProps.x}
        y={imageProps.y}
        width={imageProps.width}
        height={imageProps.height}
        ref={shapeRef}
        {...imageProps}
        draggable={isSelected}
        onDragEnd={e => {
          handleDragEnd({ imageProps, e })
          onChange({
            ...imageProps,
            x: e.target.x(),
            y: e.target.y(),
          })
          // handleDragEnd
        }}
        onTransformEnd={e => {
          const node = shapeRef.current
          const scaleX = node.scaleX()
          const scaleY = node.scaleY()

          node.scaleX(1)
          node.scaleY(1)

          onChange({
            ...imageProps,
            x: node.x(),
            y: node.y(),
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          })
        }}
      ></Image>
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox
            }
            return newBox
          }}
        />
      )}
    </React.Fragment>
  )
}

export default Canvas
